import ReferralIcon from '@material-ui/icons/Share';
import ReferralList from './ReferralList';
import ReferralCreate from './ReferralCreate';
import InvitationLink from './InvitationLink';
import InvitationLinkPage from './InvitationLinkPage';

export default {
    list: ReferralList,
    create: ReferralCreate,
    icon: ReferralIcon,
};

// 导出邀请链接组件供其他地方使用
export { InvitationLink, InvitationLinkPage };